/**
 * Number of records per page
 * ---------------------------
 */
export const rowsPerPageOptions = [10, 20, 40, 60, 80, 100];

export const FAILED_PAYMENT_WAIT_TIME = "30 minutes";
